module.exports = __webpack_public_path__ + "img/circle.5306ebf8.svg";